module.exports = __webpack_public_path__ + "static/media/icon_decline.636eadf5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_decline.svg
// module id = 2057
// module chunks = 0